export default __webpack_public_path__ + "static/media/tidy_avatar_2.10712988.png";